import './style.css'
import * as THREE from 'three'
import GUI from 'lil-gui'
import gsap from 'gsap'
// import { GLTFLoader } from 'three/examples/jsm/Addons.js'
// import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'


// /** KLAPP KLAPP */
// let klappKlapp = null

/**
 * Debug
 */
const gui = new GUI()

const parameters = {
    materialColor: '#696be7'
}

gui
    .addColor(parameters, 'materialColor')
    .onChange(() => {
        material.color.set(parameters.materialColor)
        particlesMaterial.color.set(parameters.materialColor)
    })

gui.hide()

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Objects
 */
//Texture
const textureLoader = new THREE.TextureLoader()
const gradientTexture = textureLoader.load('textures/3.jpg')

// const metalRoughnessTexture = textureLoader.load('textures/roughness/1.jpg')
// const metalBumpTexture = textureLoader.load('textures/roughness/1.jpg')
// const metalDiffTexture = textureLoader.load('textures/roughness/1.jpg')

gradientTexture.colorSpace = THREE.SRGBColorSpace
gradientTexture.magFilter = THREE.NearestFilter

// Material
const material = new THREE.MeshToonMaterial({
    color: parameters.materialColor,
    gradientMap: gradientTexture
})

const testMaterial = new THREE.MeshStandardMaterial({
    color: 0xdebe54,
    metalness: 0.2,
    roughness: 0.4
})

// klappKlapp geo 

// // Draco Loader
//     const dracoLoader = new DRACOLoader()
//     dracoLoader.setDecoderPath('/draco/')

//     // gltf loader
//     const gltfLoader = new GLTFLoader()
//     gltfLoader.setDRACOLoader(dracoLoader)
    
//     gltfLoader.load(
//         '../models/Environment/klappExport.glb',
//         (gltf) => {
//             console.log('MODEL LOADED:', gltf)
//             klappKlapp = gltf.scene
//             klappKlapp.position.set(0, -2, 0)
//             klappKlapp.scale.set(0.2, 0.2, 0.2) 
//             scene.add(klappKlapp)
            
            
            // klappKlapp.traverse((child) => {
            //     if (child.isMesh) {
            //         child.material = new THREE.MeshStandardMaterial({
            //             color: 0xdebe54, 
            //             metalness: 0.7,
            //             roughness: 0.3
            //         })
            //     }
            // })
    //     },
    //     (progress) => {
    //     console.log('gimme a sec...', progress)  
    // },
    // (error) => {
    //     console.error('puter says no:', error)  
    // }
    // )

const objectDistance = 4
/**
 * Lights
 */

// directional Light 
const directionalLight = new THREE.DirectionalLight(0xeeeeff, 7)
directionalLight.position.set(1,1,0)
scene.add(directionalLight)

/**
 * Particles
 */
// Geometry
const particlesCount = 200
const positions = new Float32Array(particlesCount * 3)

for(let i = 0; i < particlesCount; i++)
{
    positions[i * 3 + 0] = (Math.random() - 0.5) * 10
    positions[i * 3 + 1] = objectDistance * 0.5 - Math.random() * objectDistance * 4
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

//Material
const particlesMaterial = new THREE.PointsMaterial({
    color: parameters.materialColor,
    sizeAttenuation: true, 
    size: 0.03
})

// Points 
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */

// Group 
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
cameraGroup.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true })
if (document.body.classList.contains('blog-cursor')) {
    renderer.setClearColor(0x000000, 0)
} 

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputColorSpace = THREE.SRGBColorSpace

/**
 * Scroll
 */
let scrollY = window.scrollY

window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY
});

/**
 * Cursor 
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove',(event) =>
{
    cursor.x = event.clientX /sizes.width
    cursor.y = event.clientY /sizes.height

    //console.log(cursor)
})

/**
 * Animate
 */
const clock = new THREE.Clock()

let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    //console.log(deltaTime)

    // Animate camera
    camera.position.y = - scrollY / sizes.height * objectDistance

    const parallaxX = cursor.x
    const parallaxY = - cursor.y
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 4 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 4 * deltaTime

    // Animate meshes

    // if (klappKlapp) {
    //     // klappKlapp.rotation.x += deltaTime * 0.08
    //     klappKlapp.rotation.y += deltaTime * 0.1
    //     // klappKlapp.rotation.z += deltaTime * 0.03  
    // }

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
       